export const getSizeValues = (size, theme) => {
  const defs = {
    default: {
      fontSize: theme.inputDefaultFontSize,
      labelFontSize: theme.inputDefaultLabelFontSize,
      lineHeight: theme.inputDefaultLineHt,
      footerAlign: theme.inputDefaultFooterAlign,
      height: theme.inputDefaultHeight,
    },
    small: {
      fontSize: theme.inputSmallFontSize,
      labelFontSize: theme.inputSmallLabelFontSize,
      lineHeight: theme.inputSmallLineHt,
      footerAlign: theme.inputSmallFooterAlign,
    },
    large: {
      fontSize: theme.inputLargeFontSize,
      labelFontSize: theme.inputLargeLabelFontSize,
      lineHeight: theme.inputLargeLineHt,
      footerAlign: theme.inputLargeFooterAlign,
    },
  }
  return defs[size]
}
